import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var upload = normalize.upload(function (options) {
  var url = options.url,
      filePath = options.filePath,
      fileName = options.fileName,
      hideLoading = options.hideLoading,
      header = options.header,
      formData = options.formData,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete,
      timeout = options.timeout;
  return wx.uploadFile({
    url: url,
    filePath: filePath,
    name: fileName,
    hideLoading: hideLoading,
    header: header,
    timeout: timeout,
    formData: formData,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.WECHAT);
export default upload;